// The order the results list shows search results in. The map hover uses
// the same order, so "#3" on the map and in the list is the same site.
//
// Results from the harbour + capacity screen arrive ranked by the siting
// brief (zoning, capacity test, spare capacity, readiness:
// services/harbour_screen.screen_rank_key) and keep that order. Until
// 2026-10-12 the list re-sorted them by slope band and readiness, which
// threw the brief's ranking away while each card said "ranked by the siting
// brief". Other searches keep the display re-sort the list has used since
// 2026-06: capacity tier, then slope band, then readiness. Both kinds keep
// industrial sites ahead of rezoning candidates.

const CAPACITY_RANK = {
  sufficient: 0, partial: 1, capacity_inquiry: 2,
  voltage_overkill: 3, voltage_upgrade: 4, saturated: 5,
};
const capacityRank = (t) => CAPACITY_RANK[t?._capacityContext?.tier_classification] ?? 9;
const slopeRank = (t) => {
  const s = t?.slope_pct;
  if (s == null) return 9;
  if (s <= 15) return 0;
  if (s <= 25) return 1;
  if (s <= 35) return 2;
  return 3;
};
const sortKey = (a, b) => (capacityRank(a) - capacityRank(b))
  || (slopeRank(a) - slopeRank(b))
  || ((b.readiness_score || 0) - (a.readiness_score || 0));

export function isBriefRanked(results) {
  return (results || []).some(t => t && t.harbour_screen);
}

export function displayOrder(results) {
  const all = results || [];
  const briefRanked = isBriefRanked(all);
  const industrial = all.filter(r => (r.result_tier || 'industrial') === 'industrial');
  const rezoning = all.filter(r => r.result_tier === 'rezoning');
  if (!briefRanked) {
    industrial.sort(sortKey);
    rezoning.sort(sortKey);
  }
  return { industrial, rezoning, ordered: [...industrial, ...rezoning], briefRanked };
}

// {result object -> its number in the list}. Lives here, not in
// SiteScreener: that file imports react-map-gl's component as `Map`, and a
// `new Map()` there constructed the component ("Map is not a constructor",
// the search map crashed on 2026-10-12).
export function rankOf(results) {
  const ranks = new globalThis.Map();
  displayOrder(results).ordered.forEach((t, i) => ranks.set(t, i + 1));
  return ranks;
}
